import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Admin.css';

const AdminLayout = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { user, loading, signOut, isAdmin } = useAuth();
    const [authChecked, setAuthChecked] = useState(false);

    // Auth check using Supabase session
    useEffect(() => {
        if (!loading) {
            setAuthChecked(true);
            if (!user || !isAdmin()) {
                navigate('/admin/login', { replace: true, state: { from: location.pathname } });
            }
        }
    }, [user, loading, navigate, isAdmin, location.pathname]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleLogout = async () => {
        try {
            await signOut();
            navigate('/admin/login');
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    // Show loading while checking auth
    if (loading || !authChecked) {
        return (
            <div className="admin-loading-screen">
                <div className="admin-loading-spinner"></div>
                <p>Verifying authentication...</p>
            </div>
        );
    }

    // Don't render if not admin
    if (!user || !isAdmin()) {
        return null;
    }

    return (
        <div className="admin-container">
            {/* Mobile Toggle Button */}
            <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
                {isSidebarOpen ? '✕' : '☰'}
            </button>

            {/* Sidebar */}
            <aside className={`admin-sidebar ${isSidebarOpen ? 'open' : ''}`}>
                <h2>Admin Panel</h2>

                <nav className="sidebar-nav">
                    <NavLink to="/admin/dashboard" className="sidebar-link">
                        Dashboard
                    </NavLink>

                    <NavLink to="/admin/enquiries" className="sidebar-link">
                        Enquiries
                    </NavLink>

                    <NavLink to="/admin/sessions" className="sidebar-link">
                        Sessions
                    </NavLink>

                    <NavLink to="/admin/notifications" className="sidebar-link">
                        Notifications
                    </NavLink>

                    <NavLink
                        to="/admin/chat-enquiries"
                        className={({ isActive }) => isActive ? "sidebar-link active" : "sidebar-link"}
                        onClick={() => setIsSidebarOpen(false)}
                    >
                        Chat Queries
                    </NavLink>

                    <NavLink to="/admin/calendar-requests" className="sidebar-link">
    Expert Scheduling
</NavLink> 


<NavLink to="/admin/change-password" className="sidebar-link">
  Change Password
</NavLink>

                    <NavLink to="/admin/jobs" className="sidebar-link">
                        Jobs Control
                    </NavLink>

                    <NavLink to="/admin/events-control" className="sidebar-link">
                        Events Control
                    </NavLink>

                    <NavLink to="/admin/settings" className="sidebar-link">
                        Settings
                    </NavLink>

                    <div style={{ marginTop: 'auto', borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '10px' }}>
                        <button
                            onClick={handleLogout}
                            className="sidebar-link"
                            style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left', cursor: 'pointer' }}
                        >
                            Logout
                        </button>

                        <NavLink to="/" className="sidebar-link" style={{ fontSize: '0.9rem' }}>
                            ← Back to Site
                        </NavLink>
                    </div>
                </nav>
            </aside>

            {/* Main Content */}
            <main
                className="admin-content"
                onClick={() => isSidebarOpen && setIsSidebarOpen(false)}
            >
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
